import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Edit, Trash2, Plus } from 'lucide-react';
import toast from 'react-hot-toast';
import AdminLayout from '../../components/admin/AdminLayout';
import api from '../../utils/api';

export default function AdminLeadership() {
  const [leaders, setLeaders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadLeadership = useCallback(() => {
    setLoading(true);
    api.get('/admin/leadership')
      .then((res) => setLeaders(res.data))
      .catch(() => setError('Nuk arritëm të ngarkonim udhëheqjen.'))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { loadLeadership(); }, [loadLeadership]);

  const handleDelete = async (id) => {
    if (!window.confirm('A jeni të sigurt që doni të fshini këtë udhëheqës?')) return;
    try {
      await api.delete(`/admin/leadership/${id}`);
      toast.success('Udhëheqësi u fshi.');
      loadLeadership();
    } catch {
      toast.error('Gabim gjatë fshirjes.');
    }
  };

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <div>
          <h1 className="page-title">Udhëheqja</h1>
          <p className="admin-page-sub">Lista e udhëheqësve në spital</p>
        </div>
        <Link to="/admin/udheheqja/i-ri" className="btn btn-primary">
          <Plus size={15}/> Udhëheqës i ri
        </Link>
      </div>

      <div className="card">
        {error && <div className="alert alert-error" style={{ marginBottom: '1rem' }}>{error}</div>}
        {loading ? (
          <div className="spinner" />
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Emri</th>
                  <th>Pozicioni</th>
                  <th>Departamenti</th>
                  <th>Email</th>
                  <th>Telefon</th>
                  <th>Veprimet</th>
                </tr>
              </thead>
              <tbody>
                {leaders.map((leader) => (
                  <tr key={leader.id}>
                    <td>{leader.id}</td>
                    <td>{leader.name}</td>
                    <td>{leader.position}</td>
                    <td>{leader.department_name || '—'}</td>
                    <td>{leader.email || '—'}</td>
                    <td>{leader.phone || '—'}</td>
                    <td>
                      <div className="action-btns">
                        <Link to={`/admin/udheheqja/${leader.id}/ndrysho`} className="btn btn-secondary btn-sm">
                          <Edit size={13}/>
                        </Link>
                        <button className="btn btn-danger btn-sm" onClick={() => handleDelete(leader.id)}>
                          <Trash2 size={13}/>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {leaders.length === 0 && (
                  <tr>
                    <td colSpan={7} style={{ textAlign: 'center', color: 'var(--gray-400)', padding: '2rem' }}>
                      Nuk ka udhëheqje.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
